import { API, graphqlOperation } from "aws-amplify";
import { createUSER, updateUSER } from "../../graphql/mutations";
import { getUSER } from "../../graphql/queries";

export const CreateUSER = async (postParams) => {
  try {
    const result = await API.graphql(graphqlOperation(createUSER, postParams));
    return result;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const getUSERSet = async (id) => {
  try {
    console.log("user", id);
    const result = await API.graphql(
      graphqlOperation(getUSER, { user_id: id })
    );
    const data = result.data.getUSER;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const UpdateUSER = async (postParams) => {
  try {
    const result = await API.graphql(graphqlOperation(updateUSER, postParams));
    return result.data.updateUSER;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};
